import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AppSwitchState {
  activeApp: 'emr' | 'hr';
}

const initialState: AppSwitchState = {
  activeApp: 'emr',
};

const appSwitchSlice = createSlice({
  name: 'appSwitch',
  initialState,
  reducers: {
    setActiveApp: (state, action: PayloadAction<'emr' | 'hr'>) => {
      state.activeApp = action.payload;
    },
  },
});

export const {setActiveApp} = appSwitchSlice.actions;

export default appSwitchSlice.reducer;
